export function FullPageLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center text-center">
      <div>
        <h3 className="text-base font-semibold">Lade cleverfleet Plattform...</h3>
        <p className="mt-1 text-sm text-muted-foreground">Bitte warte einen kurzen Moment.</p>
      </div>
    </div>
  );
}
